/**
 * Disables addition of specified blocks either globally or based on content type
 */

const restrictedBlocks = ['gridBlock'];

const restrictedBlocksByCT: Record<string, string[]> = {};

const allowedBlocksByCT: Record<string, string[]> = {
  application: [
    'DegreeProgram',
    'ContinuingEducation',
    'FHNWEvent',
    'InfoEvent',
  ],
  sub_topics: ['Topic'],
} as Record<string, string[]>;

interface RestrictBlockProps {
  block: {
    id: string;
  };
  contentType?: string;
}

const restrictBlock =
  (restricted: boolean | ((props: RestrictBlockProps) => boolean)) =>
  (props: RestrictBlockProps): boolean => {
    if (typeof restricted === 'boolean' && restricted) {
      return true;
    }

    if (restrictedBlocks.includes(props.block.id)) {
      return true;
    }

    if (
      props?.contentType &&
      props.block.id in restrictedBlocksByCT &&
      restrictedBlocksByCT[props.block.id].includes(props?.contentType)
    ) {
      return true;
    }

    if (
      props?.contentType &&
      props.block.id in allowedBlocksByCT &&
      !allowedBlocksByCT[props.block.id].includes(props?.contentType)
    ) {
      return true;
    }

    if (typeof restricted === 'function') {
      return restricted(props);
    }

    return false;
  };

export default restrictBlock;
